import React from 'react';
import '../patients/PatientsTable.css';
import './LaboratoryOrdersTable.css';

const LaboratoryOrdersTable = ({
  orders,
  timezone,
  manualStatusOptions,
  getDisplayStatus,
  formatLaboratoryDate,
  onEdit,
  onStatusChange,
  onCancel,
  onUpload,
  uploadingOrderId
}) => {
  return (
    <div className="laboratory-orders-table-container">
      <table className="laboratory-orders-table">
        <thead>
          <tr>
            <th>Paciente</th>
            <th>Trabajo</th>
            <th>Proveedor</th>
            <th>Entrega</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => {
            const displayStatus = getDisplayStatus(order, timezone);

            return (
              <tr key={order.id} className="clickable-row" onClick={() => onEdit(order)}>
                <td className="order-patient-cell">
                  <div className="name-cell">
                    <div className="patient-avatar-small order-avatar-small">
                      <i className="fas fa-flask"></i>
                    </div>
                    <div className="order-primary-copy">
                      <span className="order-patient-name">{order.patientName || 'Sin paciente'}</span>
                      <span className="order-secondary-copy">Dr. {order.doctorName || 'Sin odontologo'}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="order-primary-copy">
                    <span className="order-work-type">{order.workType || '-'}</span>
                  </div>
                </td>
                <td>{order.providerName || '-'}</td>
                <td>{formatLaboratoryDate(order.requestedDeliveryDate, timezone)}</td>
                <td>
                  <select
                    value={order.status}
                    onClick={(event) => event.stopPropagation()}
                    onChange={(event) => onStatusChange(order.id, event.target.value)}
                    className={`status-select laboratory-status-select ${displayStatus}`}
                    aria-label={`Estado de la orden de ${order.patientName || 'laboratorio'}`}
                  >
                    {manualStatusOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </td>
                <td className="actions-cell" onClick={(event) => event.stopPropagation()}>
                  <div className="table-actions laboratory-table-actions">
                    <button
                      type="button"
                      className="btn btn-primary btn-icon btn-sm"
                      onClick={() => onEdit(order)}
                      title="Editar"
                      aria-label="Editar"
                    >
                      <i className="fas fa-pen" aria-hidden="true"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger btn-icon btn-sm"
                      onClick={() => onCancel(order)}
                      title="Cancelar"
                      aria-label="Cancelar"
                      disabled={order.status === 'cancelled'}
                    >
                      <i className="fas fa-ban" aria-hidden="true"></i>
                    </button>
                    <input
                      id={`order-upload-${order.id}`}
                      type="file"
                      multiple
                      onChange={(event) => onUpload(order.id, event)}
                      style={{ display: 'none' }}
                    />
                    <button
                      type="button"
                      className="btn btn-secondary btn-icon btn-sm"
                      onClick={() => document.getElementById(`order-upload-${order.id}`)?.click()}
                      disabled={uploadingOrderId === order.id}
                      title="Adjuntar archivo"
                      aria-label="Adjuntar archivo"
                    >
                      <i className={`fas ${uploadingOrderId === order.id ? 'fa-spinner fa-spin' : 'fa-paperclip'}`} aria-hidden="true"></i>
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LaboratoryOrdersTable;